import Base from '../Base';

export interface ConfigGLOBAL extends Base {
    userFields: IField[];
}

// Name and type are nullable in case of new extra fields
export interface IField {
    id?: string;
    name?: string; 
    type?: FieldType; 
    undeletable?: boolean;
    value?: string[];
    groupsPermission?: any;
    createdBy?: any;
}
export enum FieldType {
    BOOLEAN = 1,
    DATE = 2,
    NUMBER = 3,
    TEXT = 4,
    LIST = 5
}
